angular.module('impactx.rfx').controller('RFQCSelectionCtrl', RFQCSelectionCtrl);

RFQCSelectionCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'themeFactory', 'TranslationService'];

function RFQCSelectionCtrl($scope, dataGen, $mdDialog, themeFactory, TranslationService)
{
    var ctrl = this;
    
    $scope.data = ctrl.data.data;
    $scope.trns = ctrl.data.trns;
    $scope.theme = themeFactory.getTheme();
    $scope.searchText = {label: TranslationService.get("search"), value: ""};

    ctrl.answer = function(){
        if(impactX.isDefined($scope, 'data.rfqc.selected.id')) {
            $mdDialog.hide($scope.data.rfqc.selected.id);
        }
    };
    
    ctrl.select = function(entry){
        if($scope.data.rfqc.selected && entry && $scope.data.rfqc.selected.id === entry.id){
            $scope.data.rfqc.selected = null;
        }
        else if(entry) {
            $scope.data.rfqc.selected = entry;
        }
    };

    ctrl.cancel = function(){
        $mdDialog.cancel();
    };

    ctrl.searchRFQC = function () {
        var paramObj = {
            type: ctrl.type,
            id: ctrl.id,
            searchText: $scope.searchText.value
        };
        dataGen.postAsForm({}, paramObj, '/rfx/rfqc/select').then(function (data) {
            $scope.data = data.data;
        });
    };
}